import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../css/TrackGenre.less";

const MAX_GENRE_DISPLAY_LENGTH = 25;

const TrackGenre = ({ track, label }) => {
  if (!track.genre) {
    return null;
  }
  const displayGenre = track.genre.length > MAX_GENRE_DISPLAY_LENGTH
    ? track.genre.slice(0, MAX_GENRE_DISPLAY_LENGTH) + "…"
    : track.genre;
  return (
    <span className={"fileunder " + (label ? "with-label" : "")}>
      {label && <span>File Under:</span>}&nbsp;
      {track.total_tracks_genre >= 5 && <FontAwesomeIcon icon="trophy" className="trophy fa-trophy" />}
      &nbsp;<Link to={`/genre/${track.genre_id}`} title={track.genre}>{displayGenre}</Link>
      &nbsp;
      <span className="num-in-genre" style={{ fontSize: "10px" }}>
        ( {track.total_tracks_genre} )
      </span>
    </span>
  );
};

TrackGenre.propTypes = {
  track: PropTypes.object.isRequired,
  label: PropTypes.bool
};

TrackGenre.defaultProps = {
  label: false
};

export default TrackGenre;
